import { Component, OnDestroy, OnInit } from "@angular/core";
import { State } from "@shared/states";
import { Subscription } from "rxjs";
import { Store } from "@ngxs/store";

@Component({
    template: "app-breakpoints"
})
export abstract class BreakpointsComponent implements OnInit, OnDestroy {
    public esTelefono = false;
    public esTablet = false;

    private subsBreakpoints = new Subscription();

    protected constructor(protected store: Store) {
        const originalNgOnInit = this.ngOnInit;
        this.ngOnInit = () => {
            this.iniciar();
            originalNgOnInit.apply(this);
        };
        const originalNgOnDestroy = this.ngOnDestroy;
        this.ngOnDestroy = () => {
            this.destruir();
            originalNgOnDestroy.apply(this);
        };
    }

    public ngOnInit(): void {}

    public ngOnDestroy(): void {}

    private iniciar() {
        this.subsBreakpoints.add(
            this.store.select((state: State) => state.global.esTelefono).subscribe(esTelefono => {
                this.esTelefono = esTelefono;
            })
        );
        this.subsBreakpoints.add(
            this.store.select((state: State) => state.global.esTablet).subscribe(esTablet => {
                this.esTablet = esTablet;
            })
        );
    }

    private destruir() {
        this.subsBreakpoints.unsubscribe();
    }
}
